const PUBLIC_API_KEY = 'publicApiKey'
const CHECKOUT_RETURN_URL = 'checkoutReturnUrl'
const PAYMENT_ID = 'paymentId'
const SHOW_RESULT_SCREEN = 'showResultScreen'

export const setPublicApiKeyInLS = (publicApiKey: string): void => {
  localStorage.setItem(PUBLIC_API_KEY, publicApiKey)
}

export const getPublicApiKeyInLS = () => {
  return localStorage.getItem(PUBLIC_API_KEY)
}

export const setCheckoutReturnUrlInLS = (checkoutReturnUrl?: string): void => {
  if (checkoutReturnUrl) {
    localStorage.setItem(CHECKOUT_RETURN_URL, checkoutReturnUrl)
  } else {
    localStorage.removeItem(CHECKOUT_RETURN_URL)
  }
}

export const getCheckoutReturnUrlInLS = () => {
  return localStorage.getItem(CHECKOUT_RETURN_URL)
}

export const setPaymentIdInLS = (paymentId: string): void => {
  localStorage.setItem(PAYMENT_ID, paymentId)
}

export const getPaymentIdInLS = (): string | null => {
  return localStorage.getItem(PAYMENT_ID)
}

export const setShowResultScreenInLS = (show: boolean): void => {
  localStorage.setItem(SHOW_RESULT_SCREEN, String(show))
}

export const getShowResultScreenInLS = (): boolean => {
  return localStorage.getItem(SHOW_RESULT_SCREEN) === 'true'
}
